import slugify from "speakingurl";
import { neverHere } from "../tsHelpers";

export const asArray = () => [
  TransferType.Car,
  TransferType.Bus,
  TransferType.Train,
  TransferType.ScheduledFlight,
  TransferType.Boat,
  TransferType.Mixed,
  TransferType.Other,
];

export const toFriendlyName = (type: TransferType) => {
  switch (type) {
    case TransferType.ScheduledFlight:
      return "Scheduled flight";
    case TransferType.Car:
      return "Car";
    case TransferType.Bus:
      return "Bus";
    case TransferType.Train:
      return "Train";
    case TransferType.Boat:
      return "Boat";
    case TransferType.Mixed:
      return "Mixed";
    case TransferType.Other:
      return "Other";
    default:
      return neverHere(type);
  }
};

export const toSlug = (type: TransferType) => type ?? slugify(toFriendlyName(type));

export const icomoon = (type: TransferType) => {
  switch (type) {
    case TransferType.ScheduledFlight:
      return "icon-airplane2";
    case TransferType.Car:
      return "icon-car";
    case TransferType.Bus:
      return "icon-bus";
    case TransferType.Train:
      return "icon-train2";
    case TransferType.Boat:
      return "icon-ship";
    case TransferType.Mixed:
      return "icon-shuffle";
    case TransferType.Other:
      return "icon-menu";
    default:
      neverHere(type);
  }
};
